<template lang="pug">
div
  div.header
    img( src="@/assets/arrow-left.svg" @click="backPage" )
    span.ml-2.text-20-b Активные задания
  div.tasks-container
    div.task-block.mt-4(v-for="task in returnTaskList")
      div.task-title
        span.text-14 {{ task.title }}
        span.text-16.price + {{ task.price }} {{convertToValueLabel('RUR')}}
      div.task-status( :class="{'status-completed' : task.status === 'completed', 'status-check' : task.status === 'in progress'}" )
        span.text-12.status-text {{ returnTaskStatus(task.status) }}
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TaskList',

  mounted() {
    if(!this.taskList){
      this.loadTaskList()
    }
  },

  computed: {
    ...mapState('tasks', ['taskList', 'testTask']),

    returnTaskList() {
      return this.taskList
    }
  },

  methods: {
    ...mapActions('tasks', ['loadTaskList', 'getFormTask', 'createTestTask']),

    returnTaskStatus(status) {
      switch(status) {
        case "completed":
          return "Выполнено"
        case "in progress":
          return "Проверяется"
        default:
          return ""
      }
    },

    backPage() {
      this.$router.back()
    }
  }
}
</script>
<style scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 42px;
  padding-left: 8px;
}
.tasks-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 26px;
  width: 100%;
}
.task-block {
  height: 76px;
  border-radius: 16px;
  background: #FFFFFF;
  box-shadow: 0px 8px 15px 0px #0000001A;
  box-shadow: 0px 2px 6px 0px #0000001A;
  width: 100%;
  padding: 12px;
}
.task-title {
  display: flex;
}
.price {
  margin-left: auto;
  color: #FF9900;
}
.task-status {
  margin-top: 7px;
  width: 90px;
  height: 24px;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-completed {
  background: #A3D977;
  color: #FFFFFF
}
.status-check {
  background: #FDCB46;
  color: #171D33;
}
</style>
